import { Button, Classes, Dialog, Icon, Intent, Spinner } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React, { useCallback, useState } from 'react';

export type ProgressionDialogProps = {
  inProgress: boolean;
  done: boolean;
  inError: boolean;
  titleText: string;
  doneText: string;
  errorText: string;
  closeButtonText: string;
  onClose: () => void;
  onValidate?: () => void;
};
export const ProgressionDialog = ({
  done,
  doneText,
  inError,
  inProgress,
  titleText,
  errorText,
  closeButtonText,
  onClose,
  onValidate,
}: ProgressionDialogProps) => {
  return (
    <Dialog
      isOpen={inProgress || done || inError}
      title={titleText}
      isCloseButtonShown={false}
      onClose={onClose}
      canOutsideClickClose={false}
    >
      <div className={Classes.DIALOG_BODY}>
        {inProgress && (
          <>
            <Spinner />
          </>
        )}
        {done && (
          <>
            <Icon icon={IconNames.TICK} iconSize={32} intent={Intent.SUCCESS} />
            {doneText}
          </>
        )}
        {inError && (
          <>
            <Icon icon={IconNames.CROSS} iconSize={32} intent={Intent.DANGER} />
            {errorText}
          </>
        )}
      </div>
      {(done || inError) && (
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={onValidate || onClose} intent={Intent.PRIMARY}>
              {closeButtonText}
            </Button>
          </div>
        </div>
      )}
    </Dialog>
  );
};

export const useProgressionDialogState = () => {
  const [inProgress, setInProgressState] = useState(false);
  const [done, setDoneState] = useState(false);
  const [inError, setInErrorState] = useState(false);

  const reset = useCallback(() => {
    setInProgressState(false);
    setInErrorState(false);
    setDoneState(false);
  }, []);
  const setDone = useCallback(() => {
    setDoneState(true);
    setInProgressState(false);
    setInErrorState(false);
  }, []);
  const setInError = useCallback(() => {
    setInErrorState(true);
    setDoneState(false);
    setInProgressState(false);
  }, []);
  const setInProgress = useCallback(() => {
    setInProgressState(true);
    setDoneState(false);
    setInErrorState(false);
  }, []);

  return { done, inError, inProgress, setDone, setInError, setInProgress, reset };
};
